import { CompatibilityTable } from './CompatibilityTable.js';
import { TypeKind } from '../types.js';
import { TypeService } from '../services/TypeService.js';
function castString(value, ruleIndex, index) {
    if (typeof value === 'string') {
        return value;
    }
    else {
        throw new TypeError(`CompatibilityTable rule ${ruleIndex}. Value at '${index}' should be a string`);
    }
}
export class CompatibilityTableFactory {
    constructor(name, typeRef, structure, rules, when) {
        this.name = name;
        this.typeRef = typeRef;
        this.structure = structure;
        this.rules = rules;
        this.when = when;
    }
    createCompatibilityTable(schema, optionsRegistry) {
        this.findOptionIds(schema);
        this.replaceOptionIdWithOption(optionsRegistry);
        const table = new CompatibilityTable(this.structure, schema, this.typeRef);
        table.setWhen(this.when);
        table.addCompatibilityRules(...this.rules);
        return table;
    }
    replaceOptionIdWithOption(optionsRegistry) {
        for (let optionIdIndex of this.optionIdIndexes) {
            for (let ruleIndex = 0; ruleIndex < this.rules.length; ruleIndex++) {
                const rule = this.rules[ruleIndex];
                const optionId = castString(rule[optionIdIndex], ruleIndex, optionIdIndex);
                const option = optionsRegistry.getOptionById(optionId);
                rule[optionIdIndex] = option;
            }
        }
    }
    findOptionIds(schema) {
        this.optionIdIndexes = [];
        for (let columnIndex = 0; columnIndex < this.structure.columns.length; columnIndex++) {
            let columnName = this.structure.columns[columnIndex];
            const { parent, child } = TypeService.getParentChildPath(columnName);
            const typeService = new TypeService(this.typeRef, schema);
            const type = typeService.getPropertyType(parent);
            if (type.kind === TypeKind.Object) {
                const obj = type;
                const childProperty = obj.properties.find(p => p.name === child);
                if (childProperty) {
                    if (typeof childProperty.opts.needSource === 'boolean') {
                        if (childProperty.opts.needSource) {
                            this.optionIdIndexes.push(columnIndex);
                        }
                    }
                    else {
                        this.throwError(`Only property with needSource: true can be used in CompatibilityTable`);
                    }
                }
                else if (!typeService.isPropertyExternal(child)) {
                    this.throwError(`Cannot get ${child} for ${parent}`);
                }
            }
            else {
                this.throwError(`Invalid type of ${type.getTypeReference()}. Object expected`);
            }
        }
    }
    throwError(message) {
        throw new Error(`CompatibilityTable ${this.name}. ${message}`);
    }
}
//# sourceMappingURL=CompatibilityTableFactory.js.map